/**
 * smoothScroll.js — スムーススクロール
 *
 * - ページ読み込み時のハッシュスクロール
 * - ページ内アンカーリンクのスムーススクロール
 */

function animateScrollTo(to, duration = 600) {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    window.scrollTo(0, to);
    return;
  }

  const start = window.scrollY;
  const change = to - start;
  const startTime = performance.now();

  function animate(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = easeInOutQuad(progress);

    window.scrollTo(0, start + change * ease);

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  }

  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  requestAnimationFrame(animate);
}

export function smoothScrollToHash(offset = 0, duration = 600) {
  const hash = window.location.hash;

  if (hash) {
    const target = document.querySelector(hash);
    if (target) {
      const top =
        target.getBoundingClientRect().top + window.scrollY - offset;
      animateScrollTo(top, duration);
    }
  }
}

export function setupAnchorLinks(offset = 0, duration = 600) {
  const anchorLinks = document.querySelectorAll('a[href*="#"]:not([href="#"])');

  anchorLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const href = this.getAttribute("href");
      const hash = href.substring(href.indexOf("#"));
      const target = document.querySelector(hash);

      if (target) {
        e.preventDefault();

        const top =
          target.getBoundingClientRect().top + window.scrollY - offset;

        window.history.pushState(null, null, hash);
        animateScrollTo(top, duration);
      }
    });
  });
}
